import { useEffect, useState } from 'react'
import { navigation } from '../../data/site-content'
import { Link, NavLink } from 'react-router-dom'
import headerLogo from '../../../assets/aexion-logo-header.webp'

export function Header() {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 24)
    window.addEventListener('scroll', update, { passive: true })
    update()
    return () => window.removeEventListener('scroll', update)
  }, [])

  useEffect(() => {
    if (!open) return
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', closeOnEscape)
    return () => document.removeEventListener('keydown', closeOnEscape)
  }, [open])

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <Link className="logo magnetic" to="/" aria-label="AEXION Studios — início">
        <img src={headerLogo} alt="AEXION Studios" width="240" height="178" />
      </Link>
      <button
        className="menu-button"
        type="button"
        aria-label={open ? 'Fechar menu' : 'Abrir menu'}
        aria-expanded={open}
        aria-controls="main-navigation"
        onClick={() => setOpen((value) => !value)}
      >
        {open ? '✕' : '☰'}
      </button>
      <nav id="main-navigation" className={`nav ${open ? 'open' : ''}`} aria-label="Navegação principal">
        {navigation.map((item) => (
          <NavLink key={item.href} to={item.href} end={item.href === '/'} onClick={() => setOpen(false)}>{item.label}</NavLink>
        ))}
      </nav>
      <div className="socials" aria-label="Redes sociais em breve"><span>◉</span><span>▶</span><span>◎</span></div>
      <Link className="outline-button contact-top magnetic" to="/contato">Entre em contato</Link>
    </header>
  )
}
